import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface HeroSectionProps {
  onExploreClick: () => void;
}

export default function HeroSection({ onExploreClick }: HeroSectionProps) {
  return (
    <section className="relative h-[600px] lg:h-[700px] overflow-hidden py-[70px]">
      <div className="absolute inset-0">
        <AppImage
          src="/assets/images/Page2Hero-1770122338621.jpg"
          alt="Industrial laser cutting machine in operation showing precision metal fabrication"
          className="w-full h-full object-cover"
          priority />
      </div>
      
      <div className="relative z-10 container mx-auto px-4 lg:px-8 h-full flex items-center">
        <div className="max-w-3xl">
          <div className="inline-flex items-center space-x-2 backdrop-blur-sm px-4 py-2 rounded-full mb-6 bg-[rgba(255,255,255,0.102)] border-[rgba(255,255,255,0.2)] border-t border-b border-l border-r">
            <Icon name="SparklesIcon" size={20} variant="solid" className="text-accent" />
            <span className="text-sm font-cta font-semibold text-white">Advanced Fabrication Technology</span>
          </div>
          
          <h1 className="text-4xl lg:text-6xl font-headline font-bold text-white mb-6 leading-tight">
            Cut. Punch. Bend.<br />
            <span className="text-accent">Precision Delivered.</span>
          </h1>
          
          <p className="text-lg lg:text-xl text-gray-100 mb-8 leading-relaxed">
            State-of-the-art fiber laser cutting, CNC punching, and precision bending capabilities. From concept to completion, we deliver fabrication solutions with uncompromising accuracy and efficiency.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4">
            <button
              onClick={onExploreClick}
              className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-accent text-accent-foreground rounded-md font-cta font-bold hover:opacity-80 transition-all duration-base shadow-lg">

              <span>Explore Equipment</span>
              <Icon name="ArrowRightIcon" size={20} variant="outline" />
            </button>
            
            <button className="inline-flex items-center justify-center space-x-2 px-8 py-4 bg-white/10 backdrop-blur-sm text-white border-2 border-white/30 rounded-md font-cta font-bold text-base hover:bg-white/20 transition-all duration-base border-t border-b border-l border-r">
              <Icon name="DocumentTextIcon" size={20} variant="outline" />
              <span>Technical Specs</span>
            </button>
          
          </div>
         
          <div className="mt-12 grid grid-cols-3 gap-6">
            <div className="text-center">
              <div className="text-3xl font-headline font-bold text-accent mb-1">6kW</div>
              <div className="text-sm text-gray-200">Fiber Laser Power</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-headline font-bold text-accent mb-1">±0.1mm</div>
              <div className="text-sm text-gray-200">Cutting Precision</div>
            </div>
            <div className="text-center">
              <div className="text-3xl font-headline font-bold text-accent mb-1">24/7</div>
              <div className="text-sm text-gray-200">Production Ready</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

}